/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as RadioDefault } from './radio-default.story';
export { default as RadioNoLabel } from './radio-no-label.story';
export { default as RadioDisabled } from './radio-disabled.story';
export { default as RadioHasLabelBefore } from './radio-has-label-before.story';
export { default as RadioCustomLabel } from './radio-custom-label.story';
export { default as RadioTruncatedLabel } from './radio-truncated-label.story';
export { default as RadioControlled } from './radio-controlled.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import RadioControlledSrcRaw from './radio-controlled.story?raw';
import RadioCustomLabelSrcRaw from './radio-custom-label.story?raw';
import RadioDefaultSrcRaw from './radio-default.story?raw';
import RadioDisabledSrcRaw from './radio-disabled.story?raw';
import RadioHasLabelBeforeSrcRaw from './radio-has-label-before.story?raw';
import RadioNoLabelSrcRaw from './radio-no-label.story?raw';
import RadioTruncatedLabelSrcRaw from './radio-truncated-label.story?raw';

export const RadioDefaultSrc = removeLicenseHeader(RadioDefaultSrcRaw);
export const RadioNoLabelSrc = removeLicenseHeader(RadioNoLabelSrcRaw);
export const RadioDisabledSrc = removeLicenseHeader(RadioDisabledSrcRaw);
export const RadioHasLabelBeforeSrc = removeLicenseHeader(
  RadioHasLabelBeforeSrcRaw,
);
export const RadioCustomLabelSrc = removeLicenseHeader(RadioCustomLabelSrcRaw);
export const RadioTruncatedLabelSrc = removeLicenseHeader(
  RadioTruncatedLabelSrcRaw,
);
export const RadioControlledSrc = removeLicenseHeader(RadioControlledSrcRaw);
